"use strict";
exports.__esModule = true;
exports.assertCanCreateReactiveNodeStore = exports.throwError = exports.warn = void 0;
var prefix = "[prosemirror-reactive]";
exports.warn = function (message) {
    return prefix + " " + message;
};
exports.throwError = function (message) {
    throw new Error(prefix + " " + message);
};
exports.assertCanCreateReactiveNodeStore = function (nodeType, spec, idAttrKey) {
    var attrs = spec.attrs, reactiveAttrs = spec.reactiveAttrs;
    var hasIdAttr = attrs && attrs[idAttrKey];
    if (hasIdAttr) {
        var hasReactiveAttrs = reactiveAttrs && Object.keys(reactiveAttrs).length > 0;
        if (hasReactiveAttrs) {
            var reactiveAttrShadowingAttr = Object.keys(reactiveAttrs).find(function (attr) { return !!attrs[attr]; });
            if (reactiveAttrShadowingAttr) {
                exports.throwError("Reactive attr " + reactiveAttrShadowingAttr + " cannot be defined in both 'attrs' and 'reactiveAttrs'");
            }
        }
        else {
            exports.throwError("Reactive node definition for " + nodeType + " must have one or more 'reactiveAttrs'");
        }
    }
    else {
        exports.throwError("Reactive node definition for " + nodeType + " must have an ID attr called " + idAttrKey);
    }
};
